<div class="maintenance-wrapper" *transloco="let t; prefix: 'assetOverview.maintenance'">
  <div class="maintenance-filters">
    <app-search
      [placeholder]="t('searchPlaceholder')"
      [searchTerm]="searchTerm"
      [customWidth]="'490px'"
      (searchTermUpdated)="onSearchTermUpdated($event)">
    </app-search>

    <app-date-filter
      [filter]="dateFilter"
      [maxHistoryMonths]="240"
      [disabledIntervals]="[DateInterval.Half]"
      [showClearSelection]="true"
      [startUnselected]="true"
      (filterChanged)="onDateFilterChanged($event)">
    </app-date-filter>
  </div>

  <div class="maintenance">
    <div class="maintenance-header">
    <span class="maintenance-header-title">
      {{ t('title') }}
    </span>
  </div>

  @if (!isLoading) {
    <div class="maintenance-body" infiniteScroll (scrolled)="onScrollDown()" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300">
      @if (hasError && !timelineRows.length) {
        <div class="maintenance-state d-flex align-items-center justify-content-center">
          <app-error-state></app-error-state>
        </div>
      } @else if (!timelineRows.length) {
        <div class="maintenance-state d-flex align-items-center justify-content-center">
          <app-empty-state></app-empty-state>
        </div>
      }
      @for (item of timelineRows; track item.workOrderNumber) {
        <div class="maintenance-timeline"
          [class.maintenance-timeline--completed]="item.isCompleted"
          role="button" tabindex="0"
          (click)="onViewDetails(item)"
          (keydown.enter)="onViewDetails(item)">
          <app-maintenance-timeline-row
            [item]="item">
          </app-maintenance-timeline-row>
        </div>
      }
      @if (isLoadingMore) {
        <div class="d-flex justify-content-center py-3">
          <div class="spinner-border"></div>
        </div>
      }
    </div>
    } @else {
      <div class="spinner-container d-flex align-items-center justify-content-center spinner-border"></div>
    }
  </div>
</div>
